import { call, put } from "redux-saga/effects";
import { authService } from "../services/authService";
import { authConstants } from "../actions/constants/authConstants";
import { commonConstants } from "../actions/constants/commonConstants";

// OTP: Send login code
function* otpLogin(action: any): any {
  try {
    const response = yield call(authService.otpLogin, action.payload);
    if (response.success) {
      yield put({ type: authConstants.otpLoginSuccess, payload: response.resultObject });
      if (!response.resultObject?.deviceLimitReached) {
        yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
      }
    } else {
      yield put({ type: authConstants.otpLoginFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: authConstants.otpLoginFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error });
  }
}

function* otpVerify(action: any): any {
  try {
    const { silent, ...payload } = action.payload || {};
    const response = yield call(authService.otpVerify, payload);

    if (response.success) {
      yield put({ type: authConstants.otpVerifySuccess, payload: response.resultObject });
      if (!response.resultObject?.deviceLimitReached && !silent) {
        yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
      }
    } else {
      yield put({ type: authConstants.otpVerifyFailure, payload: response.errorMessage });
      if (!silent) {
        yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
      }
    }
  } catch (error) {
    yield put({ type: authConstants.otpVerifyFailure, payload: error });
    if (!action.payload?.silent) {
      yield put({ type: commonConstants.showMessageFailure, payload: error });
    }
  }
}


function* acceptInvitation(action: any): any {
  try {
    const response = yield call(authService.acceptInvitation, action.payload);
    if (response.success) {
      yield put({ type: authConstants.acceptInvitationSuccess, payload: response.resultObject });
    } else {
      yield put({ type: authConstants.acceptInvitationFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: authConstants.acceptInvitationFailure, payload: error });
  }
}

// OTP: Resend code
function* resendOtp(action: any): any {
  try {
    const response = yield call(authService.resendOtp, action.payload);
    if (response.success) {
      yield put({ type: authConstants.resendOtpSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: authConstants.resendOtpFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: authConstants.resendOtpFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error });
  }
}

// OTP: Resend code
function* renewToken(action: any): any {
  try {
    const response = yield call(authService.renewtoken, action.payload);
    if (response.success) {
      yield put({ type: authConstants.renewTokenSuccess, payload: response.resultObject });
    } else {
      yield put({ type: authConstants.renewTokenFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: authConstants.renewTokenFailure, payload: error });
  }
}

function* verifyToken(action: any): any {
  try {
    const response = yield call(authService.verifyToken, action.payload);
    if (response.success) {
      yield put({ type: authConstants.verifyTokenSuccess, payload: response.resultObject });
    } else {
      yield put({ type: authConstants.verifyTokenFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: authConstants.verifyTokenFailure, payload: error });
  }
}

function* registerTenant(action: any): any {
  try {
    const response = yield call(authService.registerTenant, action.payload);
    if (response.success) {
      yield put({ type: authConstants.registerTenantSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: authConstants.registerTenantFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: authConstants.registerTenantFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error });
  }
}

function* verifyRegistration(action: any): any {
  try {
    const response = yield call(authService.verifyRegistration, action.payload);
    if (response.success) {
      yield put({ type: authConstants.verifyRegistrationSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: authConstants.verifyRegistrationFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: authConstants.verifyRegistrationFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error });
  }
}

function* checkTenantExists(action: any): any {
  try {
    const response = yield call(authService.checkTenantExists, action.payload);
    if (response.success) {
      yield put({ type: authConstants.checkTenantExistsSuccess, payload: response.resultObject });
    } else {
      yield put({ type: authConstants.checkTenantExistsFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: authConstants.checkTenantExistsFailure, payload: error });
  }
}

function* logoutSaga(action: any): any {
  try {
    const response = yield call(authService.logout, action.payload);
    if (response.success) {
      yield put({ type: authConstants.logoutSuccess });
      yield put({ type: authConstants.userLogout });
    } else {
      yield put({ type: authConstants.logoutFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: authConstants.logoutFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error });
  } finally {
    try { localStorage.removeItem('AUTHDATA'); } catch (_) { }
    try { sessionStorage.removeItem('TS'); } catch (_) { }
  }
}

function* revokeDeviceSession(action: any): any {
  try {
    const response = yield call(authService.revokeDeviceSession, action.payload);
    if (response?.success) {
      yield put({ type: authConstants.revokeDeviceSessionSuccess, payload: response.resultObject || response });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message || 'Device logged out successfully.' });
    } else {
      yield put({ type: authConstants.revokeDeviceSessionFailure, payload: response?.errorMessage || response });
      yield put({ type: commonConstants.showMessageFailure, payload: response?.errorMessage || 'Failed to revoke device session.' });
    }
  } catch (error) {
    yield put({ type: authConstants.revokeDeviceSessionFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error });
  }
}

export const otpAuthSaga = {
  otpLogin,
  resendOtp,
  acceptInvitation,
  verifyToken,
  renewToken,
  otpVerify,
  registerTenant,
  verifyRegistration,
  checkTenantExists,
  logoutSaga,
  revokeDeviceSession,
};
